import React from 'react'
import { Row, Col } from 'antd'
import { IconHelper } from '../../helpers'

const Error404 = () => {
    const { Icon404, IconNotFoundEN, IconNotFoundTH } = IconHelper
    return (
        <>
            <Row className="container">
                <Col span={24}>
                    <div className="sec1">
                        <div className="page-notfound">
                            <Row type="flex" justify="center">
                                <Col lg={4} md={6} sm={8} xs={10}>
                                    <Icon404 width="100%" />
                                    <IconNotFoundEN width="100%" />
                                    <IconNotFoundTH width="100%" />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default Error404